import PropTypes from 'prop-types'

import AttackRow, {
  AttackDescription,
  TargetsColumn,
  HaltButton,
  DetailsChevron
} from './common/AttackRow'

import Pill from 'components/common/Pill'
import {
  formatTypePropertyWithMetadata,
  isExperimentHalting
} from 'components/alfi/alfi-utils'

export default function ApplicationAttackRow({
  attack,
  metadata = {},
  clickableRow,
  selectableRow,
  onHaltAttack,
  doFetch,
  showHaltButton,
  onRowSelected,
  checked
}) {
  const { guid: attackId, application_scope, traffic, service_states } = attack
  const { applicationQuery, trafficQuery } = metadata
  const appScope = application_scope[0] ?? {}
  const applicationName = appScope?.fields?.name
  const { query } = traffic[0]
  const isHalting = isExperimentHalting(service_states)

  return (
    <AttackRow
      data-active-attack-row
      checked={checked}
      clickableRow={clickableRow}
      selectableRow={selectableRow}
      showHaltButton={showHaltButton}
      to={`/attacks/application/${attackId}`}
      onRowSelected={onRowSelected}
    >
      <AttackDescription
        description={formatTypePropertyWithMetadata(query, trafficQuery)}
        name={formatTypePropertyWithMetadata(appScope, applicationQuery)}
      />
      <TargetsColumn>
        {applicationName ? <Pill>{applicationName}</Pill> : null}
      </TargetsColumn>
      {showHaltButton && (
        <HaltButton
          fetchAttack={doFetch}
          isHalting={isHalting}
          showHaltReason={false}
          trackingOptions={{ AttackId: attackId }}
          onConfirmRequest={onHaltAttack}
        />
      )}
      {clickableRow && <DetailsChevron />}
    </AttackRow>
  )
}

ApplicationAttackRow.propTypes = {
  attack: PropTypes.object,
  metadata: PropTypes.object,
  doFetch: PropTypes.func,
  onRowSelected: PropTypes.func,
  onHaltAttack: PropTypes.func,
  selectableRow: PropTypes.bool,
  clickableRow: PropTypes.bool,
  showHaltButton: PropTypes.bool,
  checked: PropTypes.bool
}
